import React, { useState } from "react";
import { Link } from "react-router-dom";
import SEO from './SEO';
import "bootstrap/dist/css/bootstrap.min.css";
import "../style/FleetDetail.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserFriends,
  faCouch,
  faSuitcaseRolling,
  faBriefcase,
  faShieldAlt,
  faCar,
  faGasPump,
  faSnowflake,
  faWifi,
  faMusic,
  faPhone,
  faMapMarkedAlt,
} from "@fortawesome/free-solid-svg-icons";

const FleetSUV = ({ currentLanguage }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // SUV images for carousel
  const suvImages = [
    "/images/suv.avif",
    "/images/suv.avif", // You can add more SUV images here
    "/images/suv.avif",
  ];

  const vehicleData = {
    EN: {
      title: "Premium SUV",
      subtitle: "Luxury and Comfort Combined",
      description: "Experience the perfect blend of luxury, comfort, and versatility with our premium SUV fleet. Ideal for business trips, family outings, or special occasions.",
      specifications: {
        passengers: "Up to 6 Passengers",
        seats: "Premium Leather Seats",
        largeLuggage: "4-6 Large Bags",
        carryOn: "6-8 Carry-On Bags",
        fuelType: "Premium Gasoline",
        transmission: "Automatic",
        airConditioning: "Dual-Zone Climate Control",
      },
      features: [
        "Premium leather interior",
        "Advanced safety features",
        "GPS navigation system",
        "Bluetooth connectivity",
        "Premium sound system",
        "Tinted windows",
        "Professional chauffeur",
        "Complimentary water bottles",
      ],
      perfectFor: [
        "Business meetings and corporate events",
        "Airport transfers",
        "Family trips and vacations",
        "Special occasions and celebrations",
        "City tours and sightseeing",
        "Wedding transportation",
      ],
    },
    ES: {
      title: "SUV Premium",
      subtitle: "Lujo y Comodidad Combinados",
      description: "Experimenta la perfecta combinación de lujo, comodidad y versatilidad con nuestra flota de SUV premium. Ideal para viajes de negocios, salidas familiares o ocasiones especiales.",
      specifications: {
        passengers: "Hasta 6 Pasajeros",
        seats: "Asientos de Cuero Premium",
        largeLuggage: "4-6 Maletas Grandes",
        carryOn: "6-8 Equipajes de Mano",
        fuelType: "Gasolina Premium",
        transmission: "Automático",
        airConditioning: "Control de Clima Dual",
      },
      features: [
        "Interior de cuero premium",
        "Características de seguridad avanzadas",
        "Sistema de navegación GPS",
        "Conectividad Bluetooth",
        "Sistema de sonido premium",
        "Ventanas tintadas",
        "Chofer profesional",
        "Botellas de agua de cortesía",
      ],
      perfectFor: [
        "Reuniones de negocios y eventos corporativos",
        "Traslados al aeropuerto",
        "Viajes familiares y vacaciones",
        "Ocasiones especiales y celebraciones",
        "Tours de la ciudad y turismo",
        "Transporte de bodas",
      ],
    },
    AR: {
      title: "سيارة دفع رباعي فاخرة",
      subtitle: "الفخامة والراحة معًا",
      description: "اختبر المزيج المثالي من الفخامة والراحة والتنوع مع أسطول سيارات الدفع الرباعي الفاخرة لدينا. مثالي لرحلات العمل أو النزهات العائلية أو المناسبات الخاصة.",
      specifications: {
        passengers: "حتى 6 ركاب",
        seats: "مقاعد جلدية فاخرة",
        largeLuggage: "4-6 حقائب كبيرة",
        carryOn: "6-8 حقائب يد",
        fuelType: "بنزين ممتاز",
        transmission: "أوتوماتيكي",
        airConditioning: "تحكم مناخي مزدوج",
      },
      features: [
        "تصميم داخلي جلدي فاخر",
        "ميزات أمان متقدمة",
        "نظام ملاحة GPS",
        "اتصال بلوتوث",
        "نظام صوتي فاخر",
        "نوافذ ملونة",
        "سائق محترف",
        "زجاجات مياه مجانية",
      ],
      perfectFor: [
        "الاجتماعات التجارية والأحداث المؤسسية",
        "نقل المطار",
        "الرحلات العائلية والإجازات",
        "المناسبات الخاصة والاحتفالات",
        "جولات المدينة والسياحة",
        "نقل الزفاف",
      ],
    },
  };

  const data = vehicleData[currentLanguage] || vehicleData.EN;

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % suvImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + suvImages.length) % suvImages.length);
  };

  return (
    <>
      <SEO 
        title="Premium SUV Service | Luxury SUV Transportation in Jacksonville"
        description="Premium SUV service in Jacksonville for groups and families. Spacious luxury SUVs with professional chauffeurs for airport transfers, events, and city tours."
        keywords="premium SUV Jacksonville, luxury SUV service, group transportation, family transportation, airport SUV transfer, spacious vehicle"
        canonical="/fleet/suv"
      />
      <div className="fleet-detail-container">
        {/* Hero Section with Carousel */}
        <section className="fleet-detail-hero">
          <div className="fleet-carousel-container">
            <div className="fleet-carousel">
              <img
                src={suvImages[currentImageIndex]}
                alt="Premium SUV"
                className="fleet-detail-image"
              />
              <div className="fleet-carousel-overlay"></div>
              
              {/* Carousel Controls */}
              <button className="fleet-carousel-btn prev" onClick={prevImage}>
              <span>‹</span>
            </button>
            <button className="fleet-carousel-btn next" onClick={nextImage}>
              <span>›</span>
            </button>
            
            {/* Carousel Indicators */}
            <div className="fleet-carousel-indicators">
              {suvImages.map((_, index) => (
                <button
                  key={index}
                  className={`indicator ${index === currentImageIndex ? 'active' : ''}`}
                  onClick={() => setCurrentImageIndex(index)}
                />
              ))}
            </div>
          </div>
          
          {/* Hero Content */}
          <div className="fleet-hero-content">
            <h1 className="fleet-detail-title">{data.title}</h1>
            <p className="fleet-detail-subtitle">{data.subtitle}</p>
          </div>
        </div>
      </section>

      {/* Vehicle Details Section */}
      <section className="fleet-detail-content">
        <div className="container">
          <div className="row">
            {/* Description */}
            <div className="col-lg-8">
              <div className="fleet-description">
                <h2>About This Vehicle</h2>
                <p>{data.description}</p>
              </div>

              {/* Specifications */}
              <div className="fleet-specifications">
                <h3>Vehicle Specifications</h3>
                <div className="specs-grid">
                  <div className="spec-item">
                    <FontAwesomeIcon icon={faUserFriends} className="spec-icon" />
                    <span>{data.specifications.passengers}</span>
                  </div>
                  <div className="spec-item">
                    <FontAwesomeIcon icon={faCouch} className="spec-icon" />
                    <span>{data.specifications.seats}</span>
                  </div>
                  <div className="spec-item">
                    <FontAwesomeIcon icon={faSuitcaseRolling} className="spec-icon" />
                    <span>{data.specifications.largeLuggage}</span>
                  </div>
                  <div className="spec-item">
                    <FontAwesomeIcon icon={faBriefcase} className="spec-icon" />
                    <span>{data.specifications.carryOn}</span>
                  </div>
                  <div className="spec-item">
                    <FontAwesomeIcon icon={faGasPump} className="spec-icon" />
                    <span>{data.specifications.fuelType}</span>
                  </div>
                  <div className="spec-item">
                    <FontAwesomeIcon icon={faCar} className="spec-icon" />
                    <span>{data.specifications.transmission}</span>
                  </div>
                  <div className="spec-item">
                    <FontAwesomeIcon icon={faSnowflake} className="spec-icon" />
                    <span>{data.specifications.airConditioning}</span>
                  </div>
                </div>
              </div>

              {/* Features */}
              <div className="fleet-features">
                <h3>Premium Features</h3>
                <div className="features-grid">
                  {data.features.map((feature, index) => (
                    <div key={index} className="feature-item">
                      <FontAwesomeIcon icon={faShieldAlt} className="feature-icon" />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Perfect For Sidebar */}
            <div className="col-lg-4">
              <div className="fleet-sidebar">
                <div className="perfect-for-card">
                  <h3>Perfect For</h3>
                  <ul className="perfect-for-list">
                    {data.perfectFor.map((occasion, index) => (
                      <li key={index}>
                        <FontAwesomeIcon icon={faMapMarkedAlt} className="list-icon" />
                        {occasion}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* CTA Card */}
                <div className="fleet-cta-card">
                  <h4>Ready to Book?</h4>
                  <p>Experience luxury transportation at its finest.</p>
                  <Link to="/ReservationForm" className="fleet-cta-btn">
                    <FontAwesomeIcon icon={faPhone} className="me-2" />
                    Book Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
  );
};

export default FleetSUV;
